<template>
    <VoteSimulation :should-lose="false"></VoteSimulation>
</template>

<script>
import VoteSimulation from '@/components/VoteSimulation.vue';
export default { components: {VoteSimulation} };
</script>